import type { ReactNode } from 'react';

import { BrandFooter, type FooterStep } from './BrandFooter';
import { BrandHeader } from './BrandHeader';
import { useKiosk } from '../lib/session';

interface KioskFrameProps {
  children: ReactNode;
  /**
   * 是否顯示頁首與頁尾識別帶；付款進行中等不可中斷畫面設 false。
   *
   * 名稱沿用 `showStatusBar`（原本只有頂部 status bar）以免改到十五個畫面的
   * 呼叫端；它現在同時管頁首與頁尾——那兩者要嘛一起在、要嘛一起不在。
   */
  showStatusBar?: boolean;
  /** 內容置中（Attract / 語言選擇等）。 */
  center?: boolean;
  /** 購票流程步驟指示，顯示於頁尾中央；不給則留白。 */
  step?: FooterStep;
  /** 內容區去掉左右內距（主視覺橫幅要滿版出血時用）。 */
  bleed?: boolean;
}

/**
 * 機台外框 — 1080×1920 直立版型容器。
 *
 * 三段式：頁首識別帶 · 內容 · 頁尾工具列（業主 2026-08-18 設計稿）。
 * data-fontscale 套用 A / A+ / A++ 字級（見 index.css）。
 */
export function KioskFrame({
  children,
  showStatusBar = true,
  center = false,
  step,
  bleed = false,
}: KioskFrameProps): JSX.Element {
  const { fontScale } = useKiosk();
  return (
    <div className="kiosk-frame" data-fontscale={fontScale}>
      {showStatusBar && <BrandHeader />}
      <div
        className={`k-screen${center ? ' k-screen--center' : ''}${bleed ? ' k-screen--bleed' : ''}`}
      >
        {children}
      </div>
      {showStatusBar && <BrandFooter step={step} />}
    </div>
  );
}
